import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/revenueBreakdownSagas";
import DonutList from "../../../../components/donutList/donutList";
import CONSTANTS from "../constants";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const RevenueByType = () => {
  const dispatch = useDispatch();
  const isUpdating = useSelector((state) => state.revenueBreakdown.isUpdating);

  const currencySymbol = useSelector((state) => state.revenueBreakdown.allRevenues.currencySymbol);
  const { revenuesByType, revenuesTypes, defaultCheckedItems, checkedRevenueTypeIds } = useSelector(
    (state) => state.revenueBreakdown
  );

  return isUpdating ? (
    <LoadingAnimation />
  ) : (
    <DonutList
      donutValues={revenuesByType.map((rev) => ({
        ...rev,
        value: rev.share * 100,
        type: rev.name,
        dollarValue: rev.revenue,
        url: rev.categoryTotalSalesRawDataLink,
        fontSize: 21,
        hasMinusButton: true,
        id: rev.id,
        customTitleStyle: "title-height-60",
        currencySymbol: currencySymbol,
        toolTip: "Percentage change from previous month",
        centerToolTip: "Percentage of Month to Date Revenue"
      }))}
      groupValues={revenuesTypes}
      defaultCheckedItems={defaultCheckedItems}
      selectedItems={checkedRevenueTypeIds}
      title="Select Categories"
      module=".react-section-wrapper.revenueDetailsWidget"
      selectHeight={350}
      modalHeight={450}
      modalTop={220}
      treeView
      modalMaxWidth="600px"
      modalMinWidth="300px"
      maxDonuts={CONSTANTS.MAX_DONUTS}
      onMinusButtonClick={(donutProps) =>
        dispatch(actionCreators.removeRevenueCategory(donutProps))
      }
      itemWasChecked={(items) => dispatch(actionCreators.setRevenueTypesChecked(items))}
      onSubmit={() => dispatch(actionCreators.addRevenueChart())}
    />
  );
};

export default RevenueByType;
